<template>
  <div class="p-grid">
    <Toast />
    
    <div class="p-col-12">
      <report-filter @update="update" :report_type="report_type"></report-filter>
    </div>

    <div v-if="report_data == null" class="loader">
      <scale-out class="loader-style"></scale-out>
    </div>

    <div v-if="report_data" class="p-col-12">
      <report-table :key="report_key" :headers="report_data.headers" :rows="report_data.rows" :name="report_data.name"></report-table>
    </div>

  </div>
</template>

<script>
import ReportService from '../../services/ReportService';
import ReportTable from "./ReportTable";
import ReportFilter from "./ReportFilter";
import {ScaleOut} from 'vue-loading-spinner';


export default {
  
  components: { ReportTable, ReportFilter, ScaleOut },

  data() {
    return {
      reportService: null,
      report_data: null,
      report_key: "report-key",
      carpark_list: [],		
      report_type: {name: "Clients", value: 'clients'},
    };
  },
  methods: {
    update(carparks, range_date) {
      this.reportService.getReport({"carparks": carparks, "type": this.report_type.value, "date": range_date}).then(result => {
        if (result.status === 200) {
          this.report_data = result.data.data;
        }
      });
    },
  },
  created() {
    this.reportService = new ReportService();
  },
  watch: {
    report_data: function() {
      this.report_key = Math.floor(Math.random() * 10000000);
    },
  }
};
</script>